'use client';

import { getQueryParam } from '@/utils/url';
import { Button } from '@payloadcms/ui';
import React from 'react';

import './GoogleLoginButton.scss';

import { googleLoginHref } from '../loginHref';
import { GoogleIcon } from './GoogleIcon';

const GoogleLoginButton: React.FC = () => {
  return (
    <div className="fv-social-login">
      <span className="fv-social-login__title">Or</span>
      <Button
        buttonStyle="primary"
        className="fv-google-login-button"
        size="large"
        onClick={() => {
          window.location.href = googleLoginHref(getQueryParam('redirect'));
        }}
      >
        <GoogleIcon />
        Login with Google
      </Button>
    </div>
  );
};

export default GoogleLoginButton;
